import client from "lib/apolloClient/client";
import { standardRubricElementsFragment } from "./StandardRubricFragments";

const fragmentNameMapping = {
  STANDARD_RUBRIC_DESCRIPTOR: {
    typeName: "StandardRubricDescriptor",
    fragment: "descriptor",
    fragmentName: "standardRubricDescriptorItem",
  },
  STANDARD_RUBRIC_CRITERIA: {
    typeName: "StandardRubricCriteria",
    fragment: "criteria",
    fragmentName: "standardRubricCriteriaItem",
  },
};

export const writeStandardRubricElementInCache = ({ id, data, type }) => {
  try {
    const typeName = fragmentNameMapping[type].typeName;
    const fragment = fragmentNameMapping[type].fragment;
    const fragmentName = fragmentNameMapping[type].fragmentName;

    const queryData = client.writeFragment({
      id: `${typeName}:${id}`,
      fragment: standardRubricElementsFragment[fragment],
      fragmentName: fragmentName,
      data,
    });

    return queryData || {};
  } catch (e) {
    return {};
  }
};
